import { render, staticRenderFns } from "./PhoAnalysis.vue?vue&type=template&id=3d7c8941&scoped=true"
import script from "./PhoAnalysis.vue?vue&type=script&lang=js"
export * from "./PhoAnalysis.vue?vue&type=script&lang=js"
import style0 from "./PhoAnalysis.vue?vue&type=style&index=0&id=3d7c8941&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7c8941",
  null
  
)

export default component.exports